import React from 'react';
import Desert from 'images/desert.svg';
import { Flex } from 'components/base/layout-components';
import Text, { Inline } from 'components/base/Text';
import { LINE_HEIGHT } from 'common/constants/sizes';

export const FilteredPersonNonIssues = ({ title }) => {
  return (
    <Flex direction='column' pl='medium' pb='small'>
      <Text size='large'>{title}</Text>
    </Flex>
  );
};

const EmptyData = ({ title, info, margin, pb = 'x-large', pt = 'large' }) => {
  return (
    <Flex
      pt={pt}
      pb={pb}
      direction='column'
      width='100%'
      items='center'
      justify='center'
      margin={margin}
    >
      <img src={Desert} alt='' />
      <Text pt='4rem' size='x-x-x-large' weight='300' color='shuttleGray'>
        {title}
      </Text>
      <Inline
        pt='1rem'
        size='medium'
        color='shuttleGray'
        align='center'
        lineHeight={LINE_HEIGHT.medium}
      >
        {info}
      </Inline>
    </Flex>
  );
};

export default EmptyData;
